import { LANDING_ASSETS } from "../constants/landing.constants";
import {
  FacebookGlyph,
  HeadsetGlyph,
  InstagramGlyph,
  LinkedinGlyph,
  MailGlyph,
  PhoneGlyph,
  StarRoundedGlyph,
} from "./landingIconGlyphs";

export type LandingIconName = keyof typeof LANDING_ASSETS.icons;

interface LandingIconProps {
  name: LandingIconName;
  className?: string;
}

const INLINE_GLYPHS = {
  headset: HeadsetGlyph,
  starRounded: StarRoundedGlyph,
  mail: MailGlyph,
  phone: PhoneGlyph,
  facebook: FacebookGlyph,
  instagram: InstagramGlyph,
  linkedin: LinkedinGlyph,
} as const;

/** Figma-exported SVG icons — inline glyphs where specified, else asset img */
export default function LandingIcon({ name, className = "" }: LandingIconProps) {
  const Glyph = INLINE_GLYPHS[name as keyof typeof INLINE_GLYPHS];
  if (Glyph) {
    return <Glyph className={className} />;
  }

  return (
    <img
      src={LANDING_ASSETS.icons[name]}
      alt=""
      className={className}
      aria-hidden
    />
  );
}
